// Modelos prontos de texto do LucraLink (textos proprios). Referenciados como
// "preset:<key>" em forwarding_settings.default_template_ref/template_by_provider.
export const PRESET_PREFIX = "preset:";
export const TEMPLATE_PRESETS = Object.freeze([
    {
        key: "padrao",
        name: "Padrão",
        description: "Título, preço e link, direto ao ponto.",
        body: "**{title}**\n\n💰 {priceText}\n🏷️ {discountPercent} de desconto\n🎟️ Cupom: {coupon}\n\n👉 {affiliateUrl}",
    },
    {
        key: "destaque-desconto",
        name: "Destaque de desconto",
        description: "Abre com o percentual de desconto em evidência.",
        body: "🔻 **{discountPercent} OFF**\n\n{title}\n~~{originalPrice}~~ por **{discountedPrice}**\nVocê economiza {savings}\n\n🛒 {affiliateUrl}",
    },
    {
        key: "urgencia",
        name: "Urgência",
        description: "Cria senso de tempo curto para a oferta.",
        body: "⏰ **Corre que acaba rápido!**\n\n{title}\nAgora {priceText}\n🎟️ Use o cupom {coupon}\n\nGaranta o seu antes que o preço volte:\n{affiliateUrl}",
    },
    {
        key: "recomendacao",
        name: "Recomendação",
        description: "Tom de indicação pessoal, como quem testou.",
        body: "💡 _Achado que vale a pena_\n\n{title}\nSai {priceText} na {provider}.\n\nRecomendo dar uma olhada:\n{affiliateUrl}",
    },
    {
        key: "storytelling",
        name: "Storytelling",
        description: "Conta uma mini história antes do link.",
        body: "Sabe aquele item que você vive adiando comprar?\n\n**{title}** baixou para {price} 👀\nAntes custava {originalPrice}.\n\nEra o empurrão que faltava:\n{affiliateUrl}",
    },
    {
        key: "gatilho-preco",
        name: "Gatilho de preço",
        description: "Compara o antes e o depois do preço.",
        body: "📉 **Menor preço que já vi**\n\n{title}\nDe ~~{originalPrice}~~\nPor **{price}**\n💸 {savings} a menos no bolso\n\n{affiliateUrl}",
    },
    {
        key: "simples",
        name: "Simples",
        description: "Só o essencial, sem emojis.",
        body: "{title}\n{price}\n{affiliateUrl}",
    },
    {
        key: "cupom",
        name: "Cupom",
        description: "Coloca o cupom no centro da mensagem.",
        body: "🎟️ **Cupom liberado: {coupon}**\n\n{title}\n{priceText}\n\nAplique o cupom no carrinho:\n{affiliateUrl}",
    },
]);
export const DEFAULT_PRESET_KEY = "padrao";
export function presetRef(key) {
    return `${PRESET_PREFIX}${key}`;
}
export function findPreset(key) {
    return TEMPLATE_PRESETS.find((p) => p.key === key) ?? null;
}
/** Resolve uma ref ("preset:x" ou uuid) para o corpo do template. Ref invalida
 *  ou template apagado cai no preset padrao: nenhum fluxo trava por isso. */
export function resolveTemplateBody(ref, userTemplates) {
    const fallback = findPreset(DEFAULT_PRESET_KEY).body;
    if (ref === null) {
        return fallback;
    }
    if (ref.startsWith(PRESET_PREFIX)) {
        return findPreset(ref.slice(PRESET_PREFIX.length))?.body ?? fallback;
    }
    return userTemplates.find((t) => t.id === ref)?.body ?? fallback;
}
/** Ref do template a usar para um provider: o especifico da plataforma, senao o global. */
export function templateRefFor(providerCode, defaultRef, byProvider) {
    if (providerCode !== null && byProvider[providerCode]) {
        return byProvider[providerCode];
    }
    return defaultRef;
}
//# sourceMappingURL=presets.js.map